export enum VesselRampType {
  STERN_RAMP = 'stern_ramp',
  SIDE_RAMP = 'side_ramp',
  QUARTER_RAMP = 'quarter_ramp',
}